import React from 'react';
import Hero from './Hero';

const Uses = () => {
  return (
    <div>
      <Hero />
    </div>
  );
};

export default Uses;
